import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Globe, Menu, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
const Navbar = ({
  className
}: {
  className?: string;
}) => {
  const {
    t,
    i18n
  } = useTranslation();
  const isRTL = i18n.language === "ar";
  return <nav
    aria-label={isRTL ? "التنقل العلوي" : "Top navigation"}
    className={cn("bg-white border-b sticky top-0 z-50", className)}
  >
      <div className="max-w-[2000px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <Link
              to="/"
              aria-label={isRTL ? "دليل يدل - الصفحة الرئيسية" : "Yadel - Homepage"}
              className="text-xl font-bold text-primary hover:text-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded transition-colors"
            >
              دليل يدل
            </Link>
            <div className="hidden md:flex items-center gap-6">
              <Link to="/exhibitions" className="text-gray-700 hover:text-primary focus-visible:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded transition-colors">
                {isRTL ? "المعارض" : "Exhibitions"}
              </Link>
              <Link to="/saudi-festivals" className="text-gray-700 hover:text-primary focus-visible:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded transition-colors">
                {isRTL ? "المهرجانات السعودية" : "Saudi Festivals"}
              </Link>
              <Link to="/saudi-seasons" className="text-gray-700 hover:text-primary focus-visible:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded transition-colors">
                {isRTL ? "المواسم السعودية" : "Saudi Seasons"}
              </Link>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/submit">
              <Button size="sm" className="bg-gradient-to-r from-primary to-purple-600 hover:from-primary/90 hover:to-purple-600/90 text-white gap-1.5 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
                <Plus className="w-4 h-4" aria-hidden="true" />
                <span className="hidden sm:inline">
                  {isRTL ? "أضف فعاليتك" : "Add Your Event"}
                </span>
                <span className="sm:hidden">
                  {isRTL ? "أضف" : "Add"}
                </span>
              </Button>
            </Link>
            
            <Button
              variant="ghost"
              size="icon"
              onClick={() => i18n.changeLanguage(i18n.language === "en" ? "ar" : "en")}
              aria-label={isRTL ? "تغيير اللغة" : "Change language"}
              className="rounded-full focus-visible:ring-2 focus-visible:ring-primary"
            >
              <Globe className="w-5 h-5" aria-hidden="true" />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              aria-label={isRTL ? "فتح القائمة" : "Open menu"}
              className="md:hidden focus-visible:ring-2 focus-visible:ring-primary"
            >
              <Menu className="w-5 h-5" aria-hidden="true" />
            </Button>
          </div>
        </div>
      </div>
    </nav>;
};
export default Navbar;